<template>
  <div class="flex flex-col justify-center items-center">
    <div class="result-box">
      <p class="text-normal">
        {{ $t('resultsPart1') }}
      </p>
      <p class="text-large">
        {{ percentage }}%
      </p>
      <p class="text-normal">
        {{ $t('resultsPart2') }}
      </p>
    </div>

    <button @click="handleSubmit" class="submit-btn">
      <span class="text-btn"> {{ $t('nextStep') }}</span>
      <svg id="Group_8" class="responsive-svg" data-name="Group 8" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 10.016 17.369">
        <defs>
          <clipPath id="clip-path">
            <rect id="Rectangle_20" data-name="Rectangle 20" width="10.016" height="17.369" fill="#fff" />
          </clipPath>
        </defs>
        <g id="Group_7" data-name="Group 7" clip-path="url(#clip-path)">
          <path id="Path_5" data-name="Path 5"
            d="M10.016,8.671,1.615.27l0,0h0A.949.949,0,0,0,.269,1.608h0L7.344,8.683.271,15.757h0A.949.949,0,0,0,1.611,17.1h0l8.4-8.4L10,8.683Z"
            transform="translate(0 0)" fill="#fff" />
        </g>
      </svg>
    </button>
  </div>
</template>
<script>
export default {
  props: {
    percentage: Number,
  },
  methods: {
    handleSubmit() {
      this.$emit("next-step");
    },
  },
};
</script>

<style scoped>
.result-box {
  width: 266px;
  height: 266px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  background-color: white;
  color: #CD0000;
  padding: 0 53px;
}

.text-normal {
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
}

.text-large {
  font-size: 58px;
  font-weight: 800;
  line-height: 62px;
}

.submit-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  padding-top: 20px;
  text-transform: uppercase;
}

.text-btn {
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
}

.responsive-svg {
  width: 10px;
  height: 17px;
}

@media (min-width: 900px) {
  .result-box {
    height: 55vw;
    width: 55vw;
    padding: 0 100px;
  }

  .text-normal {
    font-size: 44px;
    line-height: 52px;
  }

  .text-large {
    font-size: 150px;
    line-height: 160px;
  }

  .submit-btn {
    gap: 30px;
    padding-top: 35px;
  }

  .text-btn {
    font-size: 40px;
    line-height: 48px;
  }

  .responsive-svg {
    width: 18px;
    height: 30px;
  }
}
</style>
